import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { auth } from '../lib/api';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [done,     setDone]     = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 8)  return setError('Password must be at least 8 characters');
    setError('');
    setLoading(true);
    try {
      await auth.resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed — the link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', background: 'var(--bg-deep)' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ color: 'var(--accent-red)', marginBottom: 12 }}>
            Invalid or missing reset link.
          </div>
          <Link to="/forgot-password" style={{ color: 'var(--accent-purple)', fontSize: 13 }}>
            Request a new one →
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg-deep)',
      backgroundImage: `radial-gradient(ellipse at 60% 20%, rgba(139,127,255,0.06) 0%, transparent 60%)`
    }}>
      <div style={{ width: '100%', maxWidth: 380, padding: '0 20px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 32, fontWeight: 700, color: 'var(--text-primary)' }}>
            Sig<span style={{ color: 'var(--accent-purple)' }}>nal</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-dim)', fontFamily: 'var(--font-mono)',
                        letterSpacing: '3px', textTransform: 'uppercase', marginTop: 8 }}>
            Social Intelligence Platform
          </div>
        </div>

        <div className="card">
          {done ? (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: 32, marginBottom: 16 }}>✅</div>
              <div style={{ fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>
                Password updated!
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-dim)' }}>
                Redirecting you to sign in...
              </div>
            </div>
          ) : (
            <>
              <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 24, color: 'var(--text-primary)' }}>
                Set New Password
              </h2>

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label className="label">New Password</label>
                  <input
                    type="password" required
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Min. 8 characters"
                    minLength={8}
                  />
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label className="label">Confirm Password</label>
                  <input
                    type="password" required
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                    placeholder="••••••••"
                  />
                </div>

                {error && (
                  <div style={{ marginBottom: 16, padding: '10px 14px',
                                background: 'rgba(255,107,107,0.08)',
                                border: '1px solid rgba(255,107,107,0.2)',
                                borderRadius: 6, fontSize: 13, color: 'var(--accent-red)' }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit" className="btn btn-primary"
                  style={{ width: '100%', justifyContent: 'center' }}
                  disabled={loading}
                >
                  {loading ? <span className="pulsing">UPDATING...</span> : 'Update Password →'}
                </button>
              </form>
            </>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-dim)' }}>
          <Link to="/login" style={{ color: 'var(--accent-purple)' }}>← Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
